import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { FileText, Smartphone, Laptop } from 'lucide-react';
export function TheProduct() {
  const formats = [{
    icon: <FileText className="w-5 h-5 text-gold" data-id="element-160" />,
    label: 'PDF Blueprint'
  }, {
    icon: <Laptop className="w-5 h-5 text-gold" data-id="element-161" />,
    label: 'Desktop Ready'
  }, {
    icon: <Smartphone className="w-5 h-5 text-gold" data-id="element-162" />,
    label: 'Mobile Optimized'
  }];
  return <Section theme="onyx" className="border-b border-gold-hairline relative overflow-hidden" data-id="element-163">
      {/* Subtle gold dot pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C9A24B 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-164"></div>

      <div className="relative z-10" data-id="element-165">
        <div className="mb-6 flex flex-col items-center" data-id="element-166">
          <div className="flex items-center gap-4 mb-4" data-id="element-167">
            <div className="h-[1px] w-8 bg-gold/30" data-id="element-168"></div>
            <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-169">
              The Digital Product
            </span>
            <div className="h-[1px] w-8 bg-gold/30" data-id="element-170"></div>
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-serif font-medium mb-6 text-center text-bone leading-tight" data-id="element-171">
          A single, beautifully crafted{' '}
          <span className="text-gold italic" data-id="element-172">blueprint</span>.
        </h2>

        <p className="text-lg md:text-xl text-bone-muted text-center max-w-2xl mx-auto mb-16 font-sans leading-relaxed" data-id="element-173">
          No fluff. No padded chapters. Just the protocol — delivered as an
          instant-download PDF you can read on any device.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.9,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative max-w-4xl mx-auto" data-id="element-174">
          {/* Product image with gold hairline frame */}
          <div className="bg-black p-2 md:p-3 border border-gold-hairline shadow-editorial-dark" data-id="element-175">
            <div className="border border-gold-hairline overflow-hidden" data-id="element-176">
              <img src="https://cdn.magicpatterns.com/uploads/sQegeoMXyPqBZuUVKycqxU/heylloyd-image-1779611485942.png" alt="The Ultimate Auction Secrets Blueprint 2026 — displayed on a laptop and tablet in a dark library setting" className="w-full h-auto block" data-id="element-177" />
            </div>
          </div>

          {/* Decorative corner accents */}
          <div className="absolute -top-3 -left-3 w-6 h-6 border-l border-t border-gold/40 hidden md:block" data-id="element-178"></div>
          <div className="absolute -top-3 -right-3 w-6 h-6 border-r border-t border-gold/40 hidden md:block" data-id="element-179"></div>
          <div className="absolute -bottom-3 -left-3 w-6 h-6 border-l border-b border-gold/40 hidden md:block" data-id="element-180"></div>
          <div className="absolute -bottom-3 -right-3 w-6 h-6 border-r border-b border-gold/40 hidden md:block" data-id="element-181"></div>
        </motion.div>

        {/* Format badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-16" data-id="element-182">
          {formats.map((format, idx) => <div key={idx} className="flex items-center gap-3 px-5 py-3 bg-black border border-gold-hairline" data-id="element-183">
              {format.icon}
              <span className="text-bone text-sm font-medium tracking-wide" data-id="element-184">
                {format.label}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
}